import { render, staticRenderFns } from "./BillingPricingModal.vue?vue&type=template&id=59d24c7c"
import script from "./BillingPricingModal.vue?vue&type=script&lang=js"
export * from "./BillingPricingModal.vue?vue&type=script&lang=js"
import style0 from "./BillingPricingModal.vue?vue&type=style&index=0&id=59d24c7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports